import React, { useEffect, useRef } from 'react';

export const ClickOutside = ({ onOutsideClick, children }) => {
  const containerRef = useRef();

  useEffect(() => {
    const handleClickOutside = event => {
      if (!containerRef.current.contains(event.target) && onOutsideClick) {
        onOutsideClick(event);
      }
    };

    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, [onOutsideClick]);

  return <div ref={containerRef}>{children}</div>;
};
